import React, { useEffect, useState } from "react";

import { TooltipPlacements } from "Components/Form/ToolTipInfo";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../../context/StateContext";
import { DifferentLocation as LocationAddress } from "../../../../../models/location";
import { User } from "../../../../../models/user";
import { Status } from "../../../../../util/enums";
import Checkbox from "../../../../Form/Checkbox";
import AddressInfoForm from "../../../../Generic/AddressComponent/AddressInfoForm";
import { CheckBoxContainer } from "./styles";

interface Props {
  userForm: User | null;
  isUsingCompanyAddress: boolean;
  setUsingCompanyAddress: (value: boolean) => void;
  updateOrCreate: (value: any) => void;
  view?: boolean;
  disabled?: boolean;
}

const UserAddressComponent = ({
  view = false,
  userForm,
  isUsingCompanyAddress,
  setUsingCompanyAddress,
  updateOrCreate,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();
  const { currentUser } = useAppState();

  const [companyLocation, setCompanyLocation] = useState<LocationAddress>();

  const saveAddressInfo = (value: LocationAddress[]) => {
    updateOrCreate(
      userForm
        ? {
            ...userForm,
            location: {
              ...value[0],
              companyId: userForm.company ? userForm.company?.id : currentUser?.companyId,
              valid: true,
              status: Status.ACTIVE,
            },
            locationId: null,
          }
        : {
            location: {
              ...value[0],
              companyId: currentUser?.companyId,
              valid: true,
              status: Status.ACTIVE,
            },
            locationId: null,
          }
    );
  };

  const handleUpdateUserIfCompanyAddressIsBeenUsed = (checked: boolean) => {
    if (checked) {
      if (userForm) {
        if (companyLocation) {
          updateOrCreate({
            ...userForm,
            location: companyLocation,
            locationId: companyLocation?.id,
          });
        } else {
          updateOrCreate({
            ...userForm,
            location: currentUser?.company?.location,
            locationId: currentUser?.company?.location?.id,
          });
        }
      } else if (companyLocation) {
        updateOrCreate({
          location: companyLocation,
          locationId: companyLocation.id,
        } as User);
      } else {
        updateOrCreate({
          location: currentUser?.company?.location,
          locationId: currentUser?.company?.location?.id,
        });
      }
    } else if (userForm) {
      updateOrCreate({
        ...userForm,
        location: null,
        locationId: null,
      });
    } else {
      updateOrCreate({
        location: null,
        locationId: null,
      });
    }
  };

  useEffect(() => {
    if (userForm) {
      if (userForm.company && userForm.company.location) {
        setCompanyLocation(userForm.company.location);
      }
    }
  }, [userForm]);

  return (
    <>
      <AddressInfoForm
        containerClass="p-0"
        view={view || isUsingCompanyAddress}
        showMapIcon={false}
        addressesArray={[
          userForm?.location ||
            (isUsingCompanyAddress
              ? companyLocation || ({} as LocationAddress)
              : ({} as LocationAddress)),
        ]}
        isExpandedAddress={true}
        hasToShowOnlyOne={true}
        condition={""}
        update={(value: LocationAddress[]) => {
          saveAddressInfo(value);
        }}
      />
      <CheckBoxContainer>
        <Checkbox
          className="mt-2 mb-2"
          control={{
            "data-cy": "checkboxToUseCompanyAddress",
          }}
          label={t("useCompanyAddress")}
          checked={isUsingCompanyAddress}
          disabled={disabled || view}
          onChange={(_, checked) => {
            setUsingCompanyAddress(checked);

            handleUpdateUserIfCompanyAddressIsBeenUsed(checked);
          }}
          disabledTooltipText={t("theCompanyDoesNotHaveARegisteredAddress")}
          tooltipPlacement={TooltipPlacements.TOP}
        />
      </CheckBoxContainer>
    </>
  );
};

export default UserAddressComponent;
